import { LoadingContainer, Modal, Model, Input } from 'peach/components'
import { Switch, Route, Redirect, useRouteMatch, useParams } from 'peach/router'

import { useCompanyRoleGetAll, useCompanyRoleAdd } from 'core/types'

import CompanyRole from './CompanyRole'

const CompanyRoles = () => {
  const { url, path } = useRouteMatch()
  const { companyId } = useParams<{ companyId?: string }>()

  const { data: roles, isLoading } = useCompanyRoleGetAll({
    companyId,
    query: { limit: 100 },
  })

  const { mutateAsync: addCompanyRole } = useCompanyRoleAdd({ companyId })

  const addRole = (
    <Modal
      initialValue={{ alias: '' }}
      onSubmit={async (value) => await addCompanyRole(value)}
      title='Add Role'
      trigger
    >
      <Input formKey='alias' />
    </Modal>
  )

  return (
    <LoadingContainer isLoading={isLoading}>
      <Switch>
        <Route exact path={`${path}`}>
          {addRole}
          <Model.List json={roles} page title='Roles' />
        </Route>
        <Route path={`${path}/:roleId`}>
          <CompanyRole />
        </Route>
        <Redirect to={url} />
      </Switch>
    </LoadingContainer>
  )
}

export default CompanyRoles
